<template>
    <form v-if="status.detail" @submit.prevent="submit">
        <b-form-group :label="$t('label.name')" label-cols="3">
            <b-form-input v-model.trim="form.name" :state="submitted ? !$v.form.name.$invalid : null" />
            <b-form-invalid-feedback>{{ $t('message.requiredX', [$t('label.name')]) }}</b-form-invalid-feedback>
        </b-form-group>
        <hr class="my-3 mx-n3">
        <div class="d-flex justify-content-end">
            <b-button variant="danger" class="mr-2" @click="$emit('done')">{{ $t('label.cancel') }}</b-button>
            <b-button type="submit" variant="info" :disabled="!status.save"><span v-if="status.save">
                    {{ $t(categoryUUID ? 'label.updateX' : 'label.createX', [$t('module.catalogCategory')]) }}
                </span><b-spinner v-else small /></b-button>
        </div>
    </form>
    <div v-else class="text-center p-5"><b-spinner variant="info" /></div>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import { mapState } from 'vuex';
import { catalogCategoryMethods } from '@/state/api';
import { CATALOG_CATEGORY_MODULE } from '@/state/api/catalogCategory.state';
export default {
    name: 'CatalogCategoryForm',
    props: {
        categoryUUID: { type: String, default: '' },
        searchCriteria: { type: Object, required: true }
    },
    data() {
        return {
            submitted: false,
            form: { uuid: '', name: '' }
        };
    },
    validations: {
        form: {
            name: { required }
        }
    },
    computed: {
        ...mapState(CATALOG_CATEGORY_MODULE, ['status']),
        details() {
            return this.$store.state.api.catalogCategory.details || {};
        }
    },
    created() { this.load(); },
    methods: {
        ...catalogCategoryMethods,
        async load() {
            if (!this.categoryUUID) return;
            const result = await this.getCatalogCategory({ uuid: this.categoryUUID });
            if (result) {
                this.form = { ...this.form, ...this.details };
            }
        },
        async submit() {
            this.submitted = true; this.$v.$touch();
            if (this.$v.$invalid) return;
            const action = this.categoryUUID ? this.updateCatalogCategory : this.createCatalogCategory;
            const result = await action({ data: this.form, filter: this.searchCriteria });
            if (result?.success) {
                this.$emit('done');
            }
        },
    },
};
</script>
